import type React from 'react'
import { useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import PageWrapper from '../../../../../components/Pagewrapper'
import {
  useGetAffiliatePartnerQuery,
  useGetAffiliateStatsQuery,
} from '../../../../../redux/services/coreApi'
import type { PageTab } from '../../../../../types/internal-types'
import AffiliatePartnerDetails from './components/AffiliatePartnerDetails'
import AffiliatePartnerStats from './components/AffiliatePartnerStats'

type AffiliatePartnerScreenProps = {}

const AffiliatePartnerScreen: React.FC<AffiliatePartnerScreenProps> = () => {
  const history = useHistory()
  const { id } = useParams<{ id: string }>()

  const { data: affiliatePartner, isLoading: isLoadingPartner } =
    useGetAffiliatePartnerQuery(id)

  const { data: affiliateStats, isLoading: isLoadingStats } =
    useGetAffiliateStatsQuery({
      id,
      fromDate: undefined,
      toDate: undefined,
    })

  const isLoading = isLoadingPartner || isLoadingStats

  const [tab, setTab] = useState<'details' | 'stats'>('details')

  const tabs: PageTab[] = [
    {
      title: 'Partner Details',
      active: tab === 'details',
      onPress: () => setTab('details'),
    },
    {
      title: 'Statistics',
      active: tab === 'stats',
      onPress: () => setTab('stats'),
      amount: affiliateStats?.totalSignups.toString(),
    },
  ]

  return (
    <PageWrapper
      title={`${affiliatePartner?.name || 'Affiliate Partner'}`}
      goBack={() => history.goBack()}
      isLoading={isLoading}
      tabs={tabs}
      fixedWidth={true}
    >
      {tab === 'details' && (
        <AffiliatePartnerDetails
          affiliatePartner={affiliatePartner}
          isLoading={isLoading}
        />
      )}
      {tab === 'stats' && (
        <AffiliatePartnerStats
          affiliateStats={affiliateStats}
          isLoading={isLoading}
        />
      )}
    </PageWrapper>
  )
}

export default AffiliatePartnerScreen
